import notfoundTemplate from "../templates/pages/notfound.html?raw";

export default class NotFoundPage {
    constructor() {
      this.loadPage();
    }

    public loadPage(): void {
      document.querySelector<HTMLDivElement>("#app")!.innerHTML = notfoundTemplate;
    }
  }
